import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-order',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class BuyOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/system/buy-order/buy-order.component.ts